import React from "react";
import "./CreativeZone.css";

const CreativeZone = () => {
  return (
    <section className="creative-zone-section">
      <div className="creative-container">
        {/* Text Section */}
        <div className="creative-text">
          <p className="zone-tagline">
             Creative Zone – “Where Stories Come Alive”
          </p>
          <h2 className="creative-heading">
            Photography & Video Editing Services
          </h2>
          <p className="creative-subtext">
            We bring visuals to life through creative photography and editing.
            From professional shoots to social media reels, our creative team
            ensures your story is told beautifully.
          </p>

          <div className="creative-highlights">
            <div className="highlight-card">
              📸 Portfolio, Corporate & Event Shoots.
            </div>
            <div className="highlight-card">
              🎥 Reel & Video Editing for Brands.
            </div>
            <div className="highlight-card">
              🌈 High Quality, Budget Friendly.
            </div>
          </div>
        </div>

        {/* Gallery Section */}
        <div className="creative-gallery">
          <div className="gallery-scroll">
            <img
              src="https://images.unsplash.com/photo-1504208434309-cb69f4fe52b0"
              alt="Shoot 1"
            />
            <img
              src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d"
              alt="Shoot 2"
            />
            <img
              src="https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f"
              alt="Shoot 3"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreativeZone;
